import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    root: {
        "& .MuiTextField-root": {
            margin: theme.spacing(1),
        },
    },
    paper: {
        padding: theme.spacing(2),
    },
    form: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
    },
    fileInput: {
        width: "95%",
        margin: "20px 0px 10px 0px",
    },
    buttonSubmit: {
        margin: "10px 0px 10px 0px",
    },
    chip: {
        margin: "10px 0px 0px 0px",
    },
}));
